import cx from 'classnames';
import styles from './InitialsOverride.module.scss';
import { InitialsCombinedProps } from './types';

const usePresenter = (props: InitialsCombinedProps): InitialsCombinedProps => {
  // MANUAL OVERRIDE
  return {
    ...props,
    className: cx(props.className, styles[props.type || '']),
  };
};

export default usePresenter;
